import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { filter, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { DataSharingService } from '../shared/services/data-sharing.service';
import {
  isAuthCallbackUrl,
  peekAuthReturnUrl,
} from '../shared/services/token.util';

@Component({
  selector: 'app-fourzerofour',
  templateUrl: './fourzerofour.component.html',
  styleUrls: ['./fourzerofour.component.scss'],
  standalone: false
})
export class FourzerofourComponent implements OnInit {
  clientRole: string;

  constructor(
    private dataSharingService: DataSharingService,
    private router: Router,
    private auth: AuthService
  ) { }

  ngOnInit() {
    const pendingReturn = peekAuthReturnUrl();
    console.log('FOURZEROFOUR INIT');
    console.log('pendingReturn', pendingReturn);
    console.log('currentUrl', this.router.url);
    console.log('window.location.pathname', window.location.pathname);
    console.log('isAuthCallbackUrl()', isAuthCallbackUrl());
    if (
      pendingReturn &&
      pendingReturn !== '/' &&
      !pendingReturn.includes('fourzerofour') &&
      !isAuthCallbackUrl()
    ) {
      this.auth.isAuthenticated$
        .pipe(
          filter((authenticated) => authenticated),
          take(1)
        )
        .subscribe(() => {
          void this.router.navigateByUrl(pendingReturn, { replaceUrl: true });
        });
      return;
    }

    console.log(this.dataSharingService.clientRole);
    this.clientRole = this.dataSharingService.getRoleRoutePrefix();
    console.log(this.clientRole);
  }

  redirect() {
    window.location.href = `${environment.svagriha_url}/${this.clientRole}`;
  }
}
